import {createConfirmation} from 'react-confirm';
import ConfirmPopup from './ConfirmPopup';

export const confirm = createConfirmation(ConfirmPopup);

export function confirmWrapper(confirmation, options = {}) {
  return confirm({confirmation, options});
}
